module.exports = __webpack_public_path__ + "static/media/Poppins-SemiBold.75a03984.woff";